define( [
	"../../core",
	"../../selector"
], function( jQuery ) {
	return jQuery.expr.match.needsContext;
} );



// WEBPACK FOOTER //
// ./~/jquery/src/traversing/var/rneedsContext.js